export const DEFAULT_GUIDE_IMAGE = 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face';
export const DEFAULT_GUIDE_AVATAR_IMAGE = 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100';
export const MAX_INLINE_PHOTO_LENGTH = 50000;
export const GUEST_GUIDES_TIMEOUT_MS = 60000;
export const GUIDE_PHOTO_MAX_BYTES = 3 * 1024 * 1024;

export const FOCUS_AREA_OPTIONS = ['Marriage', 'Parenting', 'Career', 'Faith', 'Health', 'Finances'];

export const STATUS_OPTIONS = [
  { value: 'all', label: 'All Guides', color: 'gray' },
  { value: 'prospect', label: 'Prospects', color: 'blue' },
  { value: 'invited', label: 'Invited', color: 'yellow' },
  { value: 'active', label: 'Active', color: 'green' },
  { value: 'scheduled', label: 'Scheduled', color: 'purple' },
  { value: 'completed', label: 'Completed', color: 'gray' }
];

export const INVITE_STAGE_OPTIONS = [
  { value: 'not_invited', label: 'Not Invited' },
  { value: 'invited', label: 'Invited' },
  { value: 'interested', label: 'Interested' },
  { value: 'onboarding_sent', label: 'Onboarding Sent' },
  { value: 'onboarding_completed', label: 'Ready to Schedule' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'completed', label: 'Completed' },
  { value: 'declined', label: 'Declined' },
  { value: 'backburner', label: 'Backburner' },
];
